import { Locales } from "@/lib/link-utils/constants.cjs"
import { getSbLocaleFromUbLocale } from "@/lib/locale-helper"
import { getCountry, getIsoLocaleFromSbLocale, getLanguageFromIsoLocale } from "@/lib/locale/locale-common-utils"

export type Market = string

export function getSupportedMarkets(): string[] {
  return Object.values(Locales.sbLocaleToUbLocale)
}

export function isSupportedMarket(market: string | undefined): market is Market {
  return !!market && getSupportedMarkets().includes(market)
}

export function getSbLocaleFromMarket(market: Market): string {
  return getSbLocaleFromUbLocale(market)
}

export function getIsoLocaleFromMarket(market: Market): string {
  return getIsoLocaleFromSbLocale(getSbLocaleFromMarket(market))
}

export function getNextIntlLocaleFromIsoLocale(isoLocale: string): string {
  const country = getCountry(isoLocale)
  const language = getLanguageFromIsoLocale(isoLocale)

  if (country === language) {
    return country
  }

  return isoLocale.toLowerCase()
}

export function getNextIntlLocaleFromMarket(market: Market): string {
  return getNextIntlLocaleFromIsoLocale(getIsoLocaleFromMarket(market))
}
